<template>
  <v-dialog :value="show" persistent max-width="500">
    <v-card>
      <v-card-title class="text-h5">
        Import de références depuis fichier CSV
      </v-card-title>
      <v-card-text>
        <v-file-input
          v-model="csvFilePath"
          label="Fichier CSV"
          accept="text/csv,text/txt"
          show-size
          :error-messages="csvFileErrors"
          @input="$v.csvFilePath.$touch()"
          @blur="$v.csvFilePath.$touch()"
        ></v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="doImport" :disabled="!valid">
          OK
        </v-btn>
        <v-btn color="success" text @click="$emit('cancel')"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { maxFileSize } from "@/validators/validators";
import { parse } from "csv-parse/browser/esm/sync";
import FournisseurService from "@/services/FournisseurService";

export default {
  name: "ReferencesImportDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      csvFilePath: null,
    };
  },
  computed: {
    valid() {
      return !this.$v.$invalid;
    },
    csvFileErrors() {
      const errors = [];
      if (!this.$v.csvFilePath.$dirty) return errors;
      !this.$v.csvFilePath.required && errors.push("Obligatoire");
      !this.$v.csvFilePath.maxFileSize && errors.push("Taille maximale: 2Mo");
      return errors;
    },
  },
  watch: {
    show() {
      this.csvFilePath = null;
      this.$v.$reset();
    },
  },

  methods: {
    async doImport() {
      // importe références
      let refsFromFile = [];
      let fileContent = await this.csvFilePath.text();
      let vm = this;
      let records = parse(fileContent, { delimiter: ";" });
      let importErrors = false;
      let index = 0;
      let msg = "";
      for (let record of records) {
        index++;
        msg = "";
        if (record[0].length < 1) {
          msg = "Intitulé référence absent";
        } else if (isNaN(record[1])) {
          msg = "id UI non numérique";
        } else if (isNaN(record[3])) {
          msg = "id CDT non numérique";
        } else if (isNaN(record[4])) {
          msg = "Quantité CDT non numérique";
        } else if (isNaN(record[6])) {
          msg = "Quantité QML non numérique";
        }

        if (msg != "") {
          importErrors = this.displayError(index, msg);
          return;
        }

        let refObj = {
          intitule: record[0],
          descriptif: record[7],
          idConditionnementEmploi: isNaN(record[1])
            ? null
            : parseInt(record[1]),
          quantiteEmploi: record[4],
          iudIdEmploi: record[2],
          idConditionnementProtege: isNaN(record[3])
            ? null
            : parseInt(record[3]),
          iudIdProtege: record[5],
          quantiteProtege: 1,
          idConditionnementCommande: 1,
          quantiteCommande: record[6],
          articlesTrousse: [],
          caracteristiques: [],
        };
        // récupérer libellés condtionnements
        let condsProms = [record[1], record[3]].map((id) => {
          if (id) {
            return FournisseurService.getConditionnement(id);
          } else {
            return Promise.resolve(true);
          }
        });
        //console.log(condsProms);
        let conds;
        try {
          conds = await Promise.all(condsProms);
          refObj.conditionnementEmploi = conds[0].data
            ? conds[0].data.libelle
            : "";
          refObj.conditionnementProtege = conds[1].data
            ? conds[1].data.libelle
            : "";
          refObj.conditionnementCommande = "UNITE(S)";
        } catch (ex) {
          this.$store.dispatch(
            "setMessage",
            `Erreur ligne ${index}: id d'un conditionnement invalide.`
          );
          this.$store.dispatch("displayError");
          importErrors = true;
        }

        refsFromFile.push(refObj);
      }

      vm.$store.dispatch("demandeEditee/addReferences", refsFromFile);
      if (!importErrors) {
        this.$emit("ok");
      }
    },
    displayError(rowIndex, message) {
      this.$store.dispatch(
        "setMessage",
        `Erreur ligne ${rowIndex}: ${message}.`
      );
    },
  },
  validations: {
    csvFilePath: {
      required,
      maxFileSize: maxFileSize(2100000), //2Mb
    },
  },
};
</script>

<style></style>
